import { FormControl, FormHelperText, MenuItem } from '@material-ui/core';
import { observer } from 'mobx-react';
import React from 'react';

import { WrappedField } from '../../../core/common/forms';
import { injectTSDI } from '../../../core/common/tsdi';
import { I18n } from '../../../core/i18n';
import { StyledSelect } from '../../../core/styles';
import { SharedContractDissolutionStore } from '../../shared-contract-dissolution-store';
import { StyledBlackInputLabel, StyledBlackLabel } from '../../styles';

export interface StudioSelectProps {
    studioId: WrappedField<number | undefined>;
    onStudioSelected?: () => void;
}

export const StudioSelect = observer((props: StudioSelectProps) => {
    const { translate } = injectTSDI(I18n);
    const { studios, getStudioInfo } = injectTSDI(
        SharedContractDissolutionStore
    );
    const { studioId, onStudioSelected } = props;

    if (!studios || !studios.length) {
        return null;
    }

    const onStudioSelect = async (selectedStudioId: unknown) => {
        if (typeof selectedStudioId !== 'number') {
            return;
        }

        studioId.reset(selectedStudioId);
        onStudioSelected?.();
        await getStudioInfo.request(selectedStudioId);
    };

    const label = studioId.value
        ? translate('public.content.common.studio')
        : translate('studioselector.studioselect');

    return (
        <FormControl
            fullWidth
            required
            variant="outlined"
            error={Boolean(studioId.error)}
        >
            <StyledBlackInputLabel
                htmlFor="contract-termination-studios-input"
                id="contract-termination-studios-label"
            >
                {label}
            </StyledBlackInputLabel>
            <StyledSelect
                inputProps={{ id: 'contract-termination-studios-input' }}
                labelId="contract-termination-studios-label"
                id="contract-termination-studios"
                value={studioId.value ?? ''}
                label={<StyledBlackLabel>{label}</StyledBlackLabel>}
                onChange={(event) =>
                    onStudioSelect(parseInt(event.target.value as string, 10))
                }
                data-role="contract-termination-studios"
            >
                <MenuItem value="" disabled>
                    {translate('studioselector.studioselect')}
                </MenuItem>
                {studios?.map((studio) => (
                    <MenuItem
                        key={studio.id}
                        value={studio.id}
                        data-role="contract-termination-studio"
                    >
                        <span data-role="contract-termination-studio-name">
                            {studio.studioPublicDto?.name}
                        </span>
                        <span>&nbsp;({studio.studioPublicDto?.city})</span>
                    </MenuItem>
                ))}
            </StyledSelect>
            {studioId.error && (
                <FormHelperText>{translate(studioId.error)}</FormHelperText>
            )}
        </FormControl>
    );
});
